import React from 'react';
import { Layout, Seo } from '@layout';
import { HorizontalAnimation } from '@components/HorizontalAnimation';
import { OurStoryHero, OurStorySection, FeaturedSection, PhotoCollection, JoinOurTeam, FooterSection } from '@sections/our-story';
import { ourStoryPageData } from '@data-ts/pages/our-story';
import { careersPageData } from '@data-ts/pages/careers';

const OurStory = () => {
  return (
    <Layout isTransparentHeader={true} transparentJoyLogoColor="mono7" transparentHeaderButtonVariant="defaultPrimeWeddingWebsites">
      <Seo title={ourStoryPageData.seo.title} description={ourStoryPageData.seo.content} canonicalURL={'https://withjoy.com/our-story/'} />
      <OurStoryHero />
      <OurStorySection />
      <FeaturedSection />
      <PhotoCollection />
      <JoinOurTeam />
      <HorizontalAnimation
        eyebrow={careersPageData.remoteTeam.eyebrow}
        title={careersPageData.remoteTeam.title}
        body={careersPageData.remoteTeam.body}
        cta={careersPageData.remoteTeam.cta}
        ctaId="ourstory"
        ctaLink={ourStoryPageData.allPostionsCta}
        paddingBottom={[550, 1000]}
        paddingTop={[10, 12]}
        animation={careersPageData.remoteTeam.animation}
      />
      <FooterSection />
    </Layout>
  );
};

export default OurStory;
